import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  LOCAL_STORAGE_ACCESS_TOKEN_KEY,
  LOCAL_STORAGE_REFRESH_TOKEN_KEY,
  LOCAL_STORAGE_STUDENT_KEY,
  LOCAL_STORAGE_USER_KEY,
} from '@config/auth';
import { EUserRole } from '@datatype/type';

interface IState {
  isAuthenticated: boolean | null;
  role: EUserRole | null;
}

const initialState: IState = {
  isAuthenticated: false,
  role: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    initialize: (state) => {
      for (const key in state) {
        state[key] = initialState[key];
      }
    },
    authenticate: (
      state,
      action: PayloadAction<{
        userKey: string;
        accessToken: string;
        refreshToken: string;
        role?: EUserRole | null;
      }>,
    ) => {
      const { userKey, accessToken, refreshToken, role } = action.payload;
      state.isAuthenticated = true;
      state.role = role ?? null;
      localStorage.setItem(LOCAL_STORAGE_USER_KEY, userKey);
      localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY, accessToken);
      localStorage.setItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY, refreshToken);
    },
    setRole: (state, action: PayloadAction<EUserRole | null>) => {
      state.role = action.payload;
    },
    unAuthenticate: (state) => {
      localStorage.removeItem(LOCAL_STORAGE_USER_KEY);
      localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY);
      localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY);
      localStorage.removeItem(LOCAL_STORAGE_STUDENT_KEY);

      for (const key in state) {
        state[key] = initialState[key];
      }
    },
  },
});

export const actions = userSlice.actions;
export default userSlice.reducer;
